import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const ALLOCATIONS: Layer = {
  id: "allocations",
  layerType: ConstraintsLayerType,
  title: "Allocations",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.POLICY,
  icon: "lt-map-pin-2-line",
  description: "Identified as suitable for development",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.DEVELOPMENT_SITES,
    categorySchema: [
      { key: "housing_outer" },
      { key: "residential_allocation" },
      { key: "mixed_use_allocation" },
      { key: "commercial_allocation" },
      { key: "employment_allocation" },
      { key: "community_allocation" },
      { key: "uncategorised_allocation" },
    ],
    statusSchema: ["adopted", "draft"],
  },
};
